import { tableStyles } from 'css/tableStyles';
import React, { useEffect, useState } from 'react';
import DataTable from 'components/DataTable';
import { DATE_FORMATS, formatDate, showError } from 'utils';
import moment from 'moment';
import styles from '../refund-report/index.module.scss';
import ExportCSVButton from 'components/ExportCSVButton';
import {  specialDiscountReport } from 'services';
import Currency from 'components/Currency/Currency';
import _ from 'lodash';
import Filters from './filters';
import CustomLink from 'components/TableLink';
import { Loading } from 'components/loading/Loading';

const columns = [
  {
    name: 'User Id',
    selector: 'userId',
    // eslint-disable-next-line react/display-name
    cell: (row)=>
      <CustomLink
        text={_.get(row, 'userId')}
        linkTo={`/users/${_.get(row, 'userId')}`}
      />,
  },
  {
    name: 'Inventory Item Id',
    selector: 'inventoryItemId',
    // eslint-disable-next-line react/display-name
    cell: (row) => 
      <CustomLink 
        text={_.get(row, 'inventoryItemId')}
        linkTo={`/inventory-items/${_.get(row,'inventoryItemId')}`}
      />,
  },
  {
    name: 'Order ID',
    selector: 'orderId',
    // eslint-disable-next-line react/display-name
    cell: (row) => 
      <CustomLink 
        text={_.get(row, 'orderId')}
        linkTo={`/orders/${_.get(row,'orderId')}`}
      />,
  },
  {
    name: 'Account Id',
    selector: 'accountId',
    // eslint-disable-next-line react/display-name
    cell: (row) => 
      <CustomLink 
        text={_.get(row, 'accountId')}
        linkTo={`/accounts/${_.get(row,'accountId')}`}
      />,
  },
  {
    name: 'User Name',
    selector: 'full_name',
    width: '120px',
  },
  {
    name: 'User Email',
    selector: 'username',
    width: '180px',
  },
  {
    name: 'Order Total ($)',
    selector: 'total',
    // eslint-disable-next-line react/display-name
    format: (row) => (<Currency amount={row.total/100} default={'-'} />),
  },
  {
    name: 'Order Subtotals ($)',
    selector: 'subtotals',
    // eslint-disable-next-line react/display-name
    format: (row) => (<Currency amount={row.subtotals} default={'-'} />),
  },
  {
    name: 'Discount Amount ($)',
    selector: 'discountAmount',
    // eslint-disable-next-line react/display-name
    format: (row) => (<Currency amount={row.discountAmount} default={'-'} />),
  },
  {
    name: 'Created At',
    selector: 'createdAt',
    sortable: true,
    width: '200px',
    format: (row) => formatDate(row.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
  },
];

const columnsForCSV = [
  {
    label: 'User Id',
    value: 'userId',
  },
  {
    label: 'User Name',
    value: 'full_name',
  },
  {
    label: 'User Email',
    value: 'username',
  },
  {
    label: 'Account Id',
    value: 'accountId',
  },
  {
    label: 'Order Id',
    value: 'orderId',
  },
  {
    label: 'Inventory Item Id',
    value: 'inventoryItemId',
  },
  {
    label: 'Order Total ($)',
    value: 'total',
  },
  {
    label: 'Order Subtotals ($)',
    value: 'subtotals',
  },
  {
    label: 'Discount Amount ($)',
    value: 'discountAmount',
  },
  {
    label: 'Created At',
    value: (row) => formatDate(row.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
  },
];

const SpecialDiscountReport = () => {
  const [data, setData] = useState<Record<string, any>[]>([]);
  const [filters, setFilters] = useState<Record<string, string>>(
    { 
      user: '', 
      startDate: moment().subtract(3, 'month').toISOString(), 
      endDate: moment().toISOString(), 
    });
  const [loading, setLoading] = useState<boolean>(false);

  const specialDiscountReportFn = async (filter) => {
    setLoading(true);
    try {
      const response = await specialDiscountReport(filter);
      setData(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterSubmit = (filters)=>{
    setFilters(filters);
    specialDiscountReportFn({ startDate: filters.startDate, endDate:filters.endDate,userId:filters.user });
  };

  return (
    <div>
      <div className={styles['header']}>
        <div className={styles['heading']}>Special Discount Report</div>
        <ExportCSVButton
          fileName={'Special_Discount_Report'}
          data={data}
          columnsForCSV={columnsForCSV}
        />
      </div>
      {loading && <Loading />}
      <Filters onSubmit={handleFilterSubmit}/>
      <DataTable
        noHeader
        data={data}
        columns={columns}
        customStyles={tableStyles}
      />
    </div>
  );
};

export default SpecialDiscountReport;